import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import OptionsDropdown from '../OptionsDropdown'
import DetailsLinks from '../DetailsLinks'
import CompactVehicleInfo from '../CompactVehicleInfo'
import AddedItemsToCart from '../AddedItemsToCart'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Link from 'components/common/Link/Link'
import { OptionsDwopdownWrapper } from 'components/MyGarage2.0/components/SharedStyles'

const Vehicle = ({
  nrOfItemsAddedToCart,
  deleteVehicle,
  openVehicleDeleteModal,
  openVehicleEditModal,
  isTrailer,
  isGenericTrailer,
  urlLinkToServiceHistory,
  urlLinkToViewCart,
  handleViewCartClick,
  searchByTireSizeUrl,
  handleUseThisVehicleClick,
  noOfVehicles,
  userVehicleId,
  navigateToVehicleDetailsPage,
  isE2EAppointment,
  isActiveVehicle,
  ...props
}) =>
  <Wrapper
    userVehicleId={ userVehicleId }
    nrOfItemsAddedToCart={ nrOfItemsAddedToCart }
    isActiveVehicle={ isActiveVehicle }
    isGenericTrailer={ isGenericTrailer } >
    <UseThisVehicleButton
      isGenericTrailer={ isGenericTrailer }
      nrOfItemsAddedToCart={ nrOfItemsAddedToCart }
      data-at-garage-vehicle-usethisvehicle
      onClick={ handleUseThisVehicleClick } >
      <Circle isGenericTrailer={ isGenericTrailer } />
      Select this vehicle
    </UseThisVehicleButton>
    <OptionsDwopdownWrapper>
      <OptionsDropdown
        openVehicleDeleteModal={ openVehicleDeleteModal }
        openVehicleEditModal={ openVehicleEditModal }
        deleteVehicle={ deleteVehicle }
        isGenericTrailer={ isGenericTrailer }
        isTrailer={ isTrailer } />
    </OptionsDwopdownWrapper>
    <VehicleInfo
      isTrailer={ isTrailer }
      isGenericTrailer={ isGenericTrailer }
      openVehicleEditModal={ openVehicleEditModal }
      userVehicleId={ userVehicleId }
      navigateToVehicleDetailsPage={ navigateToVehicleDetailsPage }
      { ...props } />
    {
      isTrailer &&
        <Link button data-at-garage-vehicle-shopbytiresize to={ searchByTireSizeUrl }>
          Shop Tires
        </Link>
    }
    { (!isTrailer && !isGenericTrailer) &&
      <DetailsLinksWrapper>
        <DetailsLinks
          navigateToVehicleDetailsPage={ navigateToVehicleDetailsPage }
          isActiveVehicle={ isActiveVehicle }
          isE2EAppointment={ isE2EAppointment }
          userVehicleId={ userVehicleId } />
      </DetailsLinksWrapper>
    }
    { Boolean(nrOfItemsAddedToCart) &&
      <CartLink
        urlLinkToViewCart={ urlLinkToViewCart }
        handleViewCartClick={ handleViewCartClick }
        nrOfItemsAddedToCart={ nrOfItemsAddedToCart } />
    }
  </Wrapper>

export default Vehicle

Vehicle.propTypes = {
  deleteVehicle: PropTypes.bool,
  formattedTireSize: PropTypes.string,
  handleUseThisVehicleClick: PropTypes.func,
  handleViewCartClick: PropTypes.func,
  isActiveVehicle: PropTypes.bool,
  isE2EAppointment: PropTypes.bool,
  isGenericTrailer: PropTypes.bool,
  isTrailer: PropTypes.bool,
  masterVehicle: PropTypes.shape({
    makeDesc: PropTypes.string,
    modelDesc: PropTypes.string,
    subModelDesc: PropTypes.string,
    yearDesc: PropTypes.string
  }),
  mileage: PropTypes.string,
  navigateToVehicleDetailsPage: PropTypes.func,
  noOfVehicles: PropTypes.number,
  nrOfItemsAddedToCart: PropTypes.number,
  openVehicleDeleteModal: PropTypes.func,
  openVehicleEditModal: PropTypes.func,
  searchByTireSizeUrl: PropTypes.string,
  urlLinkToServiceHistory: PropTypes.string,
  urlLinkToViewCart: PropTypes.string,
  userVehicleId: PropTypes.string,
  vehicleColor: PropTypes.string,
  vehicleName: PropTypes.string,
  vehicleNickname: PropTypes.string
}

const Wrapper = styled.div`
  position: relative;
  grid-area: ${props => (props.isGenericTrailer || props.isTrailer) && props.isActiveVehicle ? 'ActiveVehicle' : `Vehicle${props.userVehicleId}`};
  align-self: flex-start;
  ${props => props.isGenericTrailer && css`
    align-self: stretch;
  `}
  max-height: 250px;
  ${Media.mobile`
    max-height: unset;
  `}
  padding: 68px 20px 38px;
  ${props => Boolean(props.nrOfItemsAddedToCart) && css`
    padding: 60px 20px 38px;
  `}
  background: ${Theme.colors.white};
  border: 1px solid ${Theme.colors.light_grey};
  border-radius: 4px;
  text-align: center;
  ${Media.mobile`
    padding: 68px 20px 20px;
  `}
`

const VehicleInfo = styled(CompactVehicleInfo)`
  margin: 0 0 21px 0;
  ${props => props.isTrailer && css`
    margin: 0 0 15px 0;
  `}
  ${props => props.isGenericTrailer && css`
    margin: 0;
  `}
`

const UseThisVehicleButton = styled.div`
  position: absolute;
  left: 18px;
  top: 25px;
  ${props => Boolean(props.nrOfItemsAddedToCart) && css`
    top: 20px;
  `}
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 9px;
  color: ${Theme.colors.blue};
  border: 1px solid ${Theme.colors.blue};
  background: ${Theme.colors.white};
  ${Mixin.font.GothamBook(14)};
  cursor: pointer;
  border-radius: 10px;
  ${props => props.isGenericTrailer && css`
    pointer-events:none;
    color: ${Theme.colors.grey};
    border: 1px solid ${Theme.colors.grey};
  `}
`

const Circle = styled.div`
  margin-right: 7px;
  width: 16px;
  height: 16px;
  border: 1px solid ${Theme.colors.blue};
  border-radius: 50%;
  ${props => props.isGenericTrailer && css`
    pointer-events:none;
    color: ${Theme.colors.grey};
    border: 1px solid ${Theme.colors.grey};
  `}
`

export const DetailsLinksWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;

  button {
    margin: 0;
    padding: 7px 15px 8px;
  }

  &:first-child button {
    margin: 0 0 0 10px;
  }

  @media (max-width: 1550px) and (min-width: 1024px) {
    button,
    a {
      font-size: 12px;
      padding: 7px 10px 8px;
    }
  }

  @media (max-width: 500px) {
    button,
    a {
      padding: 7px 1px 8px !important;
      font-size: 10px;
      width: 49%;
      margin: 0;
    }
  }

  @media (max-width: 380px) {
    button,
    a {
      font-size: 8px;
    }
  }
`

const CartLink = styled(AddedItemsToCart)`
  margin: 20px 0 0 0;
`
